import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['puddle', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-2.5,-1h0.5v0.5h-0.5zM2,-1h0.5v1h-0.5zM-2.5,0h1.5v0.5h-1.5zM1,0h1.5v0.5h-1.5zM-0.5,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'puddle', d: 'M-2,-1h4v0.5h-4zM-2.5,-0.5h4.5v0.5h-4.5zM-1,0h2v0.5h-2z' },
  ],
  pixels: 31,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
